import { render, staticRenderFns } from "./detailmodal.vue?vue&type=template&id=7fe7f1a8"
import script from "./detailmodal.vue?vue&type=script&lang=js"
export * from "./detailmodal.vue?vue&type=script&lang=js"
import style0 from "./detailmodal.vue?vue&type=style&index=0&id=7fe7f1a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports